import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { Affix } from 'components';
import { LayoutContext } from 'contexts';

export const BANNER_HEIGHT = 40;

export const StyledBanner = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${BANNER_HEIGHT}px;
  background-color: ${({ $color }) => $color};
  padding: 0px 25px;
  text-align: center;
`;

export const StyledAffix = styled(Affix)`
  overflow: hidden;
  position: fixed;
  width: 100%;
  z-index: 1000; // same as the header
`;

export const useTopElementHeight = () => {
  const {
    updateTopElementHeight,
    topElementHeights: { answeringAssume, bbAssume },
  } = useContext(LayoutContext);

  useEffect(() => {
    updateTopElementHeight('featureBanner', BANNER_HEIGHT);

    return () => updateTopElementHeight('featureBanner', 0);
  }, [updateTopElementHeight]);

  const offsetTop = answeringAssume + bbAssume;

  return offsetTop;
};
